import React from 'react';
import { ButtonBase, Tooltip } from '@material-ui/core';
import CustomIcon from './CustomIcon';
import { useStyles } from './useStyles';

// Copy-to-clipboard icon, same look as the OE code copy in alternative-calculation.
export interface CopyButtonProps {
  value: string;
  tooltip: string;
  onCopied?: (value: string) => void;
}

const CopyButton: React.FC<CopyButtonProps> = ({ value, tooltip, onCopied }) => {
  const c = useStyles();

  const copyValue = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (navigator.clipboard) navigator.clipboard.writeText(value);
    if (onCopied) onCopied(value);
  };

  return (
    <Tooltip title={tooltip} placement="top">
      <ButtonBase
        className={c.codeCopy}
        style={{ padding: 2, marginLeft: 0, marginRight: -4 }}
        onClick={copyValue}
      >
        <CustomIcon name="copy" />
      </ButtonBase>
    </Tooltip>
  );
};

export default CopyButton;
